module.exports = __webpack_public_path__ + "static/media/jezyk-polski.75fa5927.png";